var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAbonnements = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 12,
    fill: "none",
    viewBox: "0 0 16 12",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.347 12H1.643C.733 12 0 11.226 0 10.287V1.713C0 .775.743 0 1.643 0h12.704c.91 0 1.643.775 1.643 1.713v8.574c0 .95-.743 1.713-1.643 1.713M1.643 1.09a.61.61 0 0 0-.597.623v8.574c0 .35.273.622.597.622h12.704a.61.61 0 0 0 .596-.622V1.713a.61.61 0 0 0-.596-.622z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.994 7.592a2.02 2.02 0 0 1-1.33-.512L.93 1.865a.567.567 0 0 1-.052-.775.514.514 0 0 1 .743-.054L7.366 6.25a.953.953 0 0 0 1.277 0l5.734-5.203a.514.514 0 0 1 .743.054.57.57 0 0 1-.052.775L9.323 7.09a1.98 1.98 0 0 1-1.33.513z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.723 11.095a.47.47 0 0 1-.345-.142l-4.856-4.55c-.22-.196-.23-.545-.042-.774a.513.513 0 0 1 .743-.043l4.856 4.549c.22.196.23.545.042.774a.53.53 0 0 1-.388.186zM1.266 11.094a.51.51 0 0 1-.387-.185.567.567 0 0 1 .042-.775l4.855-4.549a.505.505 0 0 1 .743.044.567.567 0 0 1-.042.774l-4.855 4.55a.5.5 0 0 1-.346.141z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v12H0z"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAbonnements);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Abonnements.bc77060c7708a08b74b71a2519df1068.svg";